import { Button } from '@atoms/buttons';
import { FaIcon } from '@atoms/icons';
import { Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

type ExternalIdLabelProps = {
  localizationSubset: string;
  externalId: string;
  mode?: 'sideView' | 'hoverView';
};
export function ExternalIdLabel({ externalId, mode = 'sideView', localizationSubset }: ExternalIdLabelProps) {
  const theme = useTheme();
  const [hover, setHover] = useState(false);

  const handleClick: React.MouseEventHandler<HTMLDivElement> = (evt) => {
    evt.stopPropagation();
    navigator.clipboard.writeText(externalId);
  };

  return (
    <Stack
      component="div"
      direction={'row'}
      sx={{ height: '100%', maxWidth: '100%', textOverflow: 'ellipsis', cursor: 'pointer' }}
      alignItems="center"
      justifyContent="start"
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handleClick}
      spacing={1}
    >
      <Tooltip title={<FormattedMessage id={`${localizationSubset}.tooltip`} />} placement="top">
        <Stack
          direction={'row'}
          spacing={1}
          sx={{ width: '100%', maxWidth: '100%', textOverflow: 'ellipsis', cursor: 'pointer' }}
        >
          {!hover && mode === 'hoverView' && (
            <Typography variant="caption" sx={{ marginTop: '6px', textOverflow: 'ellipsis' }}>
              {externalId}
            </Typography>
          )}
          {(hover || mode === 'sideView') && (
            <>
              <Typography variant="caption" sx={{ marginTop: '6px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">
                <FormattedMessage
                  id={`${localizationSubset}.externalIDPlaceholder`}
                  values={{
                    shiftId: externalId,
                  }}
                />
              </Typography>
              <FaIcon name="copy" width={16} height={16} />
            </>
          )}
        </Stack>
      </Tooltip>
    </Stack>
  );
}
